import { InterInstance } from '@api/config';

export const updateCRM = async (token: string, quote: any) => {
  try {
    const { data } = await InterInstance({
      method: 'put',
      url: '/crm/update-queue',
      headers: { Authorization: `Bearer ${token}` },
      data: quote,
    });
    return data;
  } catch (e) {
    return e;
  }
};
